import Bowser from "bowser";

// https://browserl.ist/?q=cover+90%25+in+DK

if (!Bowser.getParser(window.navigator.userAgent).satisfies({
    desktop: {
        chrome: ">=76",
        firefox: ">=70",
        safari: ">=11",
        opera: ">=66",
        edge: ">=17",
    },
    mobile: {
        safari: ">=11",
        chrome: ">=75",
        samsung_internet: ">=9",
        firefox: ">=65",
        uc: ">=4"
    },

    tablet: {
        safari: ">=11",
        chrome: ">=75",
        samsung_internet: ">=9",
        firefox: ">=65",
        uc: ">=4"
    }
})) {
    window.location.href = 'https://www.rently.dk/no-support';
}
